export const sectionColor = ['#a8d3d8', '#6b888c', '#4f5767', '#6b6f88', '#b1a5c8', '#98a5b7', '#c19a8e']

